export default __webpack_public_path__ + "static/media/glass.85f1bfed.png";